<template>
  <div class="themeBody" :data-theme="themeMode">
  <div class="mainBoxForm localLoginBox">

    <div class="localLoginBodyBox">

      <el-avatar id="userLogo" :size="120" :src="getAvatar"></el-avatar>

      <div class="nickName">{{ nick_name ? nick_name : ""}}</div>

      <el-button  :loading="!isGetUserInfo" class="continueLogin" @click="localLogin">{{$t('h.login.continueOnYourWay')}} QiDi Studio</el-button>

      <el-button class="loginOut" @click="logout">{{$t('h.login.loginOut')}}</el-button>

      <area-select-footer v-show="$store.state.isInSlicer==false"/>
    </div>

  </div>
  </div>

</template>

<script>
import {userInfo} from "@/api/api";
import {OnClickGetLoginInfo} from "@/utils/studioWXMessage";

export default {
  data() {
    return {
      nick_name: '',//用户名
      headimg_url: "",//头像图片url
      email: '',//用户邮箱
      old_nick_name: "",//初始用户名

      token: localStorage.getItem("token"),

      isGetUserInfo:false,
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
    isActiveSub() {
      if (this.old_nick_name !== this.nick_name && this.old_nick_name !== "") {
        return false
      } else {
        return true
      }
    },
    getAvatar() {
      if (this.headimg_url) {
        return this.headimg_url
      } else {
        //如果图片获取失败 使用默认的logo图片
        return require("~/assets/logo.png");
      }
    }
  },
  created() {
    this.getUseInfo()
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#EEEEEE')
  },
  beforeDestroy() {
    document.querySelector('body').setAttribute('style', 'background:#***')
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$store.commit('deleteUserVuex')
      this.$router.push("/account/login")
      //this.$notify.success({
      //   title: this.$t('h.common.tip'),
      //   message: this.$t('h.common.tipLoginOut'),
      // })
    },
    localLogin() {
      //发送token给软件
      OnClickGetLoginInfo(this.token)
      //vuex中存放token
      this.$store.commit("saveUserToken", this.token)
      //跳转到用户中心
      this.$router.push('/account/userCenter')
    },
    getUseInfo() {
      if (localStorage.getItem("token") === "") {
        //this.$notify.error({
        //   title: this.$t('h.common.tip'),
        //   message: this.$t('h.common.tipNeedLogin'),
        // })
        this.$router.push("/account/login")
      } else {
        console.log('有token,但还要检查token');
      }
      console.log(this.$store.state.userInfo)
      if (Object.keys(this.$store.state.userInfo).length !== 0) {
        console.log('使用已经保存的用户信息');
        this.nick_name = this.$store.state.userInfo.nick_name
        this.email = this.$store.state.userInfo.email
        this.headimg_url = this.$store.state.userInfo.headimg_url
        this.old_nick_name = this.$store.state.userInfo.nick_name
        this.isGetUserInfo=true
      } else {
        console.log('没有已经保存的用户信息,准备获取信息');
        userInfo().then((res) => {
          console.log(res)
          if (res.status === 0) {
            //this.$notify.success({
            //   title: this.$t('h.common.tip'),
            //   message: this.$t('h.common.tipGetUserInfoSuccess'),
            // })
            this.nick_name = res.data.nick_name
            this.email = res.data.email
            this.headimg_url = res.data.headimg_url
            this.old_nick_name = res.data.nick_name
            this.isGetUserInfo = true
          } else {
            this.isGetUserInfo=false
            console.warn("token可能过期了,token有误")
            this.$notify.error({
              title: this.$t('h.common.tip'),
              message: this.$t('h.common.tipGetUserInfoFail'),
            })
            this.logout()
            this.$router.push("/account/login")
          }
        }).catch((error) => {
          this.isGetUserInfo = false
          console.warn("请求超时了~")
          this.$notify.error({
            title: this.$t('h.common.tip'),
            message: this.$t('h.common.noUserInfoError'),
          })
          this.logout()
          this.$router.push("/account/login")
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

.mainBoxForm {
  @include background_color("background_color");
  @include font_color("text-color");
}

> > > .localLoginBox {
  /* 使用 Flexbox 属性 */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */

  .localLoginBodyBox {
    /* 可以设置为 Flexbox 布局 */
    display: flex;
    flex-direction: column; /* 垂直布局 */
    justify-content: center; /* 垂直居中 */
    align-items: center; /* 水平居中 */

    width: 55%;
    height: 400px;

    .nickName {
      text-align: left;
      margin: 30px 0;
      font-size: 20px;
    }

  }

  .el-button {
    width: 100%;
    margin: 0;
  }

  .continueLogin {
    color: white;
    @include background_color("qidi_blue");
    @include border_color("qidi_blue");
  }
  .continueLogin:hover{
    @include background_color("continueLoginHoverBgColor");
  }

  .loginOut {
    border: 0;
    @include background_color("background_color");
    @include font_color("qidi_blue");
    margin: 30px 0;
  }

  .loginOut:hover {
    @include background_color("loginOutBtnHoverBgColor");
  }

  #userLogo {
    @include background_color("background_color");
  }

}
</style>



// WEBPACK FOOTER //
// src/views/account/localLogin.vue